require('./bootstrap');

import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import {App, plugin} from '@inertiajs/inertia-vue'
import {InertiaProgress} from '@inertiajs/progress/src'
import VueSweetalert2 from 'vue-sweetalert2'
import vTitle from 'vuejs-title'
import VueMarqueeSlider from 'vue-marquee-slider';
import store from "./store";

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.config.productionTip = false;
Vue.mixin({methods: {route: window.route}});
Vue.use(plugin);
Vue.use(PortalVue);
Vue.use(VueMeta);
Vue.use(VueSweetalert2);
Vue.use(vTitle);
Vue.use(VueMarqueeSlider)



const instance = axios.create({
    baseURL: `${window.location.origin}/`,
    timeout: 1000 * 15,
    headers: {
        'X-CSRF-TOKEN': document.head.querySelector('meta[name="_token"]').content,
    },
})
window.$axios = instance


InertiaProgress.init({
    delay: 250,
    color: '#29d',
    includeCSS: true,
    showSpinner: false,
})
import vuetify from './vuetify'
const el = document.getElementById('app')
Vue.mixin(require('./base'))

new Vue({
    metaInfo: {
        titleTemplate: title => (title ? `${title} - YAWI CASH` : 'YAWI CASH'),
    },
    vuetify,
    store,
    render: h =>
        h(App, {
            props: {
                initialPage: JSON.parse(el.dataset.page),
                resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
            },
        }),
}).$mount(el)
